import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import page from "./components/pages/pageDetails.vue";
import home from "./components/mainPage.vue";
import newsDetails from "./components/pages/newsDetails.vue";

import newsInstitute from "./components/pages/newsInstitute.vue";
import notFound from "./components/notfound.vue";
import sitemap from "./components/SiteMap.vue";

const routes = [
    {
        path: "/",
        component: home,
        name: "home"
    },

    {
        path: "/news/:id",
        component: newsDetails,
        name: "newsDetails"
    },

    {
        path: "/mapa-strony",
        component: sitemap,
        name: "sitemap"
    },
    {
        path: "/:categorySlug*",
        component: page,
        name: "page"
    },


    {
        path: "*",
        component: notFound,
        name: "notfound"
    }

    /*

*/
];

export default new VueRouter({
    mode: "history",
    routes
});
